import React, { useState } from "react";
import { Box, Button, Card, CardContent, TextField, Typography } from "@mui/material";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import baseURL from "../config";


const AccountsLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Please enter email and password");
      return;
    }

    try {
      const expiryTime = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
      const response = await axios.post(`${baseURL}/api/login`, formData);

      if (response.status === 200 && response.data && response.data.user) {
        const user = response.data.user;

        // ✅ Check if this is an "account" user
        if (user.userType !== "account") {
          toast.error("This login is only for account users");
          return;
        }

        // Save session
        Cookies.set("userEmail", user.email, { expires: 1 });
        localStorage.setItem("userType", user.userType);
        localStorage.setItem("user id", user.id);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("expiryTime", expiryTime);

        toast.success("Account Login successful!");

        // ✅ Redirect "account" users somewhere
        if (!user.urlId || user.urlId.trim() === "") {
          navigate("/accounts/secure/dashboard"); 
        } else {
          navigate(`/accounts/${user.urlId}/dashboard`);
        }
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err.response?.data?.message || "Something went wrong during login");
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Card sx={{ maxWidth: 400, width: "100%", boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" textAlign="center" mb={2}>
            Account Login
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
            />

            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              margin="normal"
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ mt: 2, backgroundColor: "#1976d2" }}
            >
              Login
            </Button>
          </form>
        </CardContent>
      </Card>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default AccountsLogin;
